/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as R403RouteImport } from './routes/403'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminStoreMappingIndexRouteImport } from './routes/admin/store-mapping/index'
import { Route as AdminMenuPreviewIndexRouteImport } from './routes/admin/menu-preview/index'
import { Route as AdminMenuCategoryIndexRouteImport } from './routes/admin/menu-category/index'
import { Route as AdminItemMappingIndexRouteImport } from './routes/admin/item-mapping/index'
import { Route as AdminInboundOrderIndexRouteImport } from './routes/admin/inbound-order/index'
import { Route as AdminDashboardIndexRouteImport } from './routes/admin/dashboard/index'
import { Route as AdminCronSettingIndexRouteImport } from './routes/admin/cron-setting/index'
import { Route as AdminChannelLogIndexRouteImport } from './routes/admin/channel-log/index'
import { Route as AdminChannelConfigIndexRouteImport } from './routes/admin/channel-config/index'
import { Route as AdminCategoryMapIndexRouteImport } from './routes/admin/category-map/index'
import { Route as AdminCategoryGroupIndexRouteImport } from './routes/admin/category-group/index'
import { Route as AdminCampaignIndexRouteImport } from './routes/admin/campaign/index'
import { Route as AdminBackgroundJobIndexRouteImport } from './routes/admin/background-job/index'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/auth/reset-password/$token'
import { Route as AdminStoreMappingCreateRouteImport } from './routes/admin/store-mapping/create'
import { Route as AdminMenuCategoryCreateRouteImport } from './routes/admin/menu-category/create'
import { Route as AdminItemMappingImportRouteImport } from './routes/admin/item-mapping/import'
import { Route as AdminItemMappingCreateRouteImport } from './routes/admin/item-mapping/create'
import { Route as AdminInboundOrderOrderIdRouteImport } from './routes/admin/inbound-order/$orderId'
import { Route as AdminChannelConfigChannelIdRouteImport } from './routes/admin/channel-config/$channelId'
import { Route as AdminCategoryGroupCreateRouteImport } from './routes/admin/category-group/create'
import { Route as AdminCampaignCreateRouteImport } from './routes/admin/campaign/create'
import { Route as AdminStoreMappingIdUpdateRouteImport } from './routes/admin/store-mapping/$id/update'
import { Route as AdminStoreMappingIdDetailRouteImport } from './routes/admin/store-mapping/$id/detail'
import { Route as AdminMenuCategoryIdUpdateRouteImport } from './routes/admin/menu-category/$id/update'
import { Route as AdminMenuCategoryIdDetailRouteImport } from './routes/admin/menu-category/$id/detail'
import { Route as AdminItemMappingIdUpdateRouteImport } from './routes/admin/item-mapping/$id/update'
import { Route as AdminItemMappingIdDetailRouteImport } from './routes/admin/item-mapping/$id/detail'
import { Route as AdminCategoryMapCategoryIDUpdateRouteImport } from './routes/admin/category-map/$categoryID/update'
import { Route as AdminCategoryMapCategoryIDDetailRouteImport } from './routes/admin/category-map/$categoryID/detail'
import { Route as AdminCategoryGroupIdUpdateRouteImport } from './routes/admin/category-group/$id/update'
import { Route as AdminCategoryGroupIdPreviewRouteImport } from './routes/admin/category-group/$id/preview'
import { Route as AdminCategoryGroupIdImportRouteImport } from './routes/admin/category-group/$id/import'
import { Route as AdminCategoryGroupIdDetailRouteImport } from './routes/admin/category-group/$id/detail'
import { Route as AdminCampaignIdUpdateRouteImport } from './routes/admin/campaign/$id/update'
import { Route as AdminCampaignIdDetailRouteImport } from './routes/admin/campaign/$id/detail'
import { Route as AdminCategoryGroupIdCategoryCategoryIDProductsRouteImport } from './routes/admin/category-group/$id/category/$categoryID/products'
import { Route as AdminCategoryGroupIdCategoryCategoryIDAddProductRouteImport } from './routes/admin/category-group/$id/category/$categoryID/add-product'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckEmailRoute = CheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStoreMappingIndexRoute = AdminStoreMappingIndexRouteImport.update({
  id: '/store-mapping/',
  path: '/store-mapping/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMenuPreviewIndexRoute = AdminMenuPreviewIndexRouteImport.update({
  id: '/menu-preview/',
  path: '/menu-preview/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMenuCategoryIndexRoute = AdminMenuCategoryIndexRouteImport.update({
  id: '/menu-category/',
  path: '/menu-category/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminItemMappingIndexRoute = AdminItemMappingIndexRouteImport.update({
  id: '/item-mapping/',
  path: '/item-mapping/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInboundOrderIndexRoute = AdminInboundOrderIndexRouteImport.update({
  id: '/inbound-order/',
  path: '/inbound-order/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDashboardIndexRoute = AdminDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCronSettingIndexRoute = AdminCronSettingIndexRouteImport.update({
  id: '/cron-setting/',
  path: '/cron-setting/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminChannelLogIndexRoute = AdminChannelLogIndexRouteImport.update({
  id: '/channel-log/',
  path: '/channel-log/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminChannelConfigIndexRoute = AdminChannelConfigIndexRouteImport.update({
  id: '/channel-config/',
  path: '/channel-config/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCategoryMapIndexRoute = AdminCategoryMapIndexRouteImport.update({
  id: '/category-map/',
  path: '/category-map/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCategoryGroupIndexRoute = AdminCategoryGroupIndexRouteImport.update({
  id: '/category-group/',
  path: '/category-group/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCampaignIndexRoute = AdminCampaignIndexRouteImport.update({
  id: '/campaign/',
  path: '/campaign/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBackgroundJobIndexRoute = AdminBackgroundJobIndexRouteImport.update({
  id: '/background-job/',
  path: '/background-job/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/auth/reset-password/$token',
  path: '/auth/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStoreMappingCreateRoute = AdminStoreMappingCreateRouteImport.update({
  id: '/store-mapping/create',
  path: '/store-mapping/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMenuCategoryCreateRoute = AdminMenuCategoryCreateRouteImport.update({
  id: '/menu-category/create',
  path: '/menu-category/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminItemMappingImportRoute = AdminItemMappingImportRouteImport.update({
  id: '/item-mapping/import',
  path: '/item-mapping/import',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminItemMappingCreateRoute = AdminItemMappingCreateRouteImport.update({
  id: '/item-mapping/create',
  path: '/item-mapping/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInboundOrderOrderIdRoute =
  AdminInboundOrderOrderIdRouteImport.update({
    id: '/inbound-order/$orderId',
    path: '/inbound-order/$orderId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminChannelConfigChannelIdRoute =
  AdminChannelConfigChannelIdRouteImport.update({
    id: '/channel-config/$channelId',
    path: '/channel-config/$channelId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryGroupCreateRoute =
  AdminCategoryGroupCreateRouteImport.update({
    id: '/category-group/create',
    path: '/category-group/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCampaignCreateRoute = AdminCampaignCreateRouteImport.update({
  id: '/campaign/create',
  path: '/campaign/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStoreMappingIdUpdateRoute =
  AdminStoreMappingIdUpdateRouteImport.update({
    id: '/store-mapping/$id/update',
    path: '/store-mapping/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminStoreMappingIdDetailRoute =
  AdminStoreMappingIdDetailRouteImport.update({
    id: '/store-mapping/$id/detail',
    path: '/store-mapping/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMenuCategoryIdUpdateRoute =
  AdminMenuCategoryIdUpdateRouteImport.update({
    id: '/menu-category/$id/update',
    path: '/menu-category/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminMenuCategoryIdDetailRoute =
  AdminMenuCategoryIdDetailRouteImport.update({
    id: '/menu-category/$id/detail',
    path: '/menu-category/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminItemMappingIdUpdateRoute =
  AdminItemMappingIdUpdateRouteImport.update({
    id: '/item-mapping/$id/update',
    path: '/item-mapping/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminItemMappingIdDetailRoute =
  AdminItemMappingIdDetailRouteImport.update({
    id: '/item-mapping/$id/detail',
    path: '/item-mapping/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryMapCategoryIDUpdateRoute =
  AdminCategoryMapCategoryIDUpdateRouteImport.update({
    id: '/category-map/$categoryID/update',
    path: '/category-map/$categoryID/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryMapCategoryIDDetailRoute =
  AdminCategoryMapCategoryIDDetailRouteImport.update({
    id: '/category-map/$categoryID/detail',
    path: '/category-map/$categoryID/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryGroupIdUpdateRoute =
  AdminCategoryGroupIdUpdateRouteImport.update({
    id: '/category-group/$id/update',
    path: '/category-group/$id/update',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryGroupIdPreviewRoute =
  AdminCategoryGroupIdPreviewRouteImport.update({
    id: '/category-group/$id/preview',
    path: '/category-group/$id/preview',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryGroupIdImportRoute =
  AdminCategoryGroupIdImportRouteImport.update({
    id: '/category-group/$id/import',
    path: '/category-group/$id/import',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryGroupIdDetailRoute =
  AdminCategoryGroupIdDetailRouteImport.update({
    id: '/category-group/$id/detail',
    path: '/category-group/$id/detail',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCampaignIdUpdateRoute = AdminCampaignIdUpdateRouteImport.update({
  id: '/campaign/$id/update',
  path: '/campaign/$id/update',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCampaignIdDetailRoute = AdminCampaignIdDetailRouteImport.update({
  id: '/campaign/$id/detail',
  path: '/campaign/$id/detail',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCategoryGroupIdCategoryCategoryIDProductsRoute =
  AdminCategoryGroupIdCategoryCategoryIDProductsRouteImport.update({
    id: '/category-group/$id/category/$categoryID/products',
    path: '/category-group/$id/category/$categoryID/products',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCategoryGroupIdCategoryCategoryIDAddProductRoute =
  AdminCategoryGroupIdCategoryCategoryIDAddProductRouteImport.update({
    id: '/category-group/$id/category/$categoryID/add-product',
    path: '/category-group/$id/category/$categoryID/add-product',
    getParentRoute: () => AdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin/campaign/create': typeof AdminCampaignCreateRoute
  '/admin/category-group/create': typeof AdminCategoryGroupCreateRoute
  '/admin/channel-config/$channelId': typeof AdminChannelConfigChannelIdRoute
  '/admin/inbound-order/$orderId': typeof AdminInboundOrderOrderIdRoute
  '/admin/item-mapping/create': typeof AdminItemMappingCreateRoute
  '/admin/item-mapping/import': typeof AdminItemMappingImportRoute
  '/admin/menu-category/create': typeof AdminMenuCategoryCreateRoute
  '/admin/store-mapping/create': typeof AdminStoreMappingCreateRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/admin/background-job': typeof AdminBackgroundJobIndexRoute
  '/admin/campaign': typeof AdminCampaignIndexRoute
  '/admin/category-group': typeof AdminCategoryGroupIndexRoute
  '/admin/category-map': typeof AdminCategoryMapIndexRoute
  '/admin/channel-config': typeof AdminChannelConfigIndexRoute
  '/admin/channel-log': typeof AdminChannelLogIndexRoute
  '/admin/cron-setting': typeof AdminCronSettingIndexRoute
  '/admin/dashboard': typeof AdminDashboardIndexRoute
  '/admin/inbound-order': typeof AdminInboundOrderIndexRoute
  '/admin/item-mapping': typeof AdminItemMappingIndexRoute
  '/admin/menu-category': typeof AdminMenuCategoryIndexRoute
  '/admin/menu-preview': typeof AdminMenuPreviewIndexRoute
  '/admin/store-mapping': typeof AdminStoreMappingIndexRoute
  '/admin/campaign/$id/detail': typeof AdminCampaignIdDetailRoute
  '/admin/campaign/$id/update': typeof AdminCampaignIdUpdateRoute
  '/admin/category-group/$id/detail': typeof AdminCategoryGroupIdDetailRoute
  '/admin/category-group/$id/import': typeof AdminCategoryGroupIdImportRoute
  '/admin/category-group/$id/preview': typeof AdminCategoryGroupIdPreviewRoute
  '/admin/category-group/$id/update': typeof AdminCategoryGroupIdUpdateRoute
  '/admin/category-map/$categoryID/detail': typeof AdminCategoryMapCategoryIDDetailRoute
  '/admin/category-map/$categoryID/update': typeof AdminCategoryMapCategoryIDUpdateRoute
  '/admin/item-mapping/$id/detail': typeof AdminItemMappingIdDetailRoute
  '/admin/item-mapping/$id/update': typeof AdminItemMappingIdUpdateRoute
  '/admin/menu-category/$id/detail': typeof AdminMenuCategoryIdDetailRoute
  '/admin/menu-category/$id/update': typeof AdminMenuCategoryIdUpdateRoute
  '/admin/store-mapping/$id/detail': typeof AdminStoreMappingIdDetailRoute
  '/admin/store-mapping/$id/update': typeof AdminStoreMappingIdUpdateRoute
  '/admin/category-group/$id/category/$categoryID/add-product': typeof AdminCategoryGroupIdCategoryCategoryIDAddProductRoute
  '/admin/category-group/$id/category/$categoryID/products': typeof AdminCategoryGroupIdCategoryCategoryIDProductsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin/campaign/create': typeof AdminCampaignCreateRoute
  '/admin/category-group/create': typeof AdminCategoryGroupCreateRoute
  '/admin/channel-config/$channelId': typeof AdminChannelConfigChannelIdRoute
  '/admin/inbound-order/$orderId': typeof AdminInboundOrderOrderIdRoute
  '/admin/item-mapping/create': typeof AdminItemMappingCreateRoute
  '/admin/item-mapping/import': typeof AdminItemMappingImportRoute
  '/admin/menu-category/create': typeof AdminMenuCategoryCreateRoute
  '/admin/store-mapping/create': typeof AdminStoreMappingCreateRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/admin/background-job': typeof AdminBackgroundJobIndexRoute
  '/admin/campaign': typeof AdminCampaignIndexRoute
  '/admin/category-group': typeof AdminCategoryGroupIndexRoute
  '/admin/category-map': typeof AdminCategoryMapIndexRoute
  '/admin/channel-config': typeof AdminChannelConfigIndexRoute
  '/admin/channel-log': typeof AdminChannelLogIndexRoute
  '/admin/cron-setting': typeof AdminCronSettingIndexRoute
  '/admin/dashboard': typeof AdminDashboardIndexRoute
  '/admin/inbound-order': typeof AdminInboundOrderIndexRoute
  '/admin/item-mapping': typeof AdminItemMappingIndexRoute
  '/admin/menu-category': typeof AdminMenuCategoryIndexRoute
  '/admin/menu-preview': typeof AdminMenuPreviewIndexRoute
  '/admin/store-mapping': typeof AdminStoreMappingIndexRoute
  '/admin/campaign/$id/detail': typeof AdminCampaignIdDetailRoute
  '/admin/campaign/$id/update': typeof AdminCampaignIdUpdateRoute
  '/admin/category-group/$id/detail': typeof AdminCategoryGroupIdDetailRoute
  '/admin/category-group/$id/import': typeof AdminCategoryGroupIdImportRoute
  '/admin/category-group/$id/preview': typeof AdminCategoryGroupIdPreviewRoute
  '/admin/category-group/$id/update': typeof AdminCategoryGroupIdUpdateRoute
  '/admin/category-map/$categoryID/detail': typeof AdminCategoryMapCategoryIDDetailRoute
  '/admin/category-map/$categoryID/update': typeof AdminCategoryMapCategoryIDUpdateRoute
  '/admin/item-mapping/$id/detail': typeof AdminItemMappingIdDetailRoute
  '/admin/item-mapping/$id/update': typeof AdminItemMappingIdUpdateRoute
  '/admin/menu-category/$id/detail': typeof AdminMenuCategoryIdDetailRoute
  '/admin/menu-category/$id/update': typeof AdminMenuCategoryIdUpdateRoute
  '/admin/store-mapping/$id/detail': typeof AdminStoreMappingIdDetailRoute
  '/admin/store-mapping/$id/update': typeof AdminStoreMappingIdUpdateRoute
  '/admin/category-group/$id/category/$categoryID/add-product': typeof AdminCategoryGroupIdCategoryCategoryIDAddProductRoute
  '/admin/category-group/$id/category/$categoryID/products': typeof AdminCategoryGroupIdCategoryCategoryIDProductsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/403': typeof R403Route
  '/check-email': typeof CheckEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin/campaign/create': typeof AdminCampaignCreateRoute
  '/admin/category-group/create': typeof AdminCategoryGroupCreateRoute
  '/admin/channel-config/$channelId': typeof AdminChannelConfigChannelIdRoute
  '/admin/inbound-order/$orderId': typeof AdminInboundOrderOrderIdRoute
  '/admin/item-mapping/create': typeof AdminItemMappingCreateRoute
  '/admin/item-mapping/import': typeof AdminItemMappingImportRoute
  '/admin/menu-category/create': typeof AdminMenuCategoryCreateRoute
  '/admin/store-mapping/create': typeof AdminStoreMappingCreateRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/admin/background-job/': typeof AdminBackgroundJobIndexRoute
  '/admin/campaign/': typeof AdminCampaignIndexRoute
  '/admin/category-group/': typeof AdminCategoryGroupIndexRoute
  '/admin/category-map/': typeof AdminCategoryMapIndexRoute
  '/admin/channel-config/': typeof AdminChannelConfigIndexRoute
  '/admin/channel-log/': typeof AdminChannelLogIndexRoute
  '/admin/cron-setting/': typeof AdminCronSettingIndexRoute
  '/admin/dashboard/': typeof AdminDashboardIndexRoute
  '/admin/inbound-order/': typeof AdminInboundOrderIndexRoute
  '/admin/item-mapping/': typeof AdminItemMappingIndexRoute
  '/admin/menu-category/': typeof AdminMenuCategoryIndexRoute
  '/admin/menu-preview/': typeof AdminMenuPreviewIndexRoute
  '/admin/store-mapping/': typeof AdminStoreMappingIndexRoute
  '/admin/campaign/$id/detail': typeof AdminCampaignIdDetailRoute
  '/admin/campaign/$id/update': typeof AdminCampaignIdUpdateRoute
  '/admin/category-group/$id/detail': typeof AdminCategoryGroupIdDetailRoute
  '/admin/category-group/$id/import': typeof AdminCategoryGroupIdImportRoute
  '/admin/category-group/$id/preview': typeof AdminCategoryGroupIdPreviewRoute
  '/admin/category-group/$id/update': typeof AdminCategoryGroupIdUpdateRoute
  '/admin/category-map/$categoryID/detail': typeof AdminCategoryMapCategoryIDDetailRoute
  '/admin/category-map/$categoryID/update': typeof AdminCategoryMapCategoryIDUpdateRoute
  '/admin/item-mapping/$id/detail': typeof AdminItemMappingIdDetailRoute
  '/admin/item-mapping/$id/update': typeof AdminItemMappingIdUpdateRoute
  '/admin/menu-category/$id/detail': typeof AdminMenuCategoryIdDetailRoute
  '/admin/menu-category/$id/update': typeof AdminMenuCategoryIdUpdateRoute
  '/admin/store-mapping/$id/detail': typeof AdminStoreMappingIdDetailRoute
  '/admin/store-mapping/$id/update': typeof AdminStoreMappingIdUpdateRoute
  '/admin/category-group/$id/category/$categoryID/add-product': typeof AdminCategoryGroupIdCategoryCategoryIDAddProductRoute
  '/admin/category-group/$id/category/$categoryID/products': typeof AdminCategoryGroupIdCategoryCategoryIDProductsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/admin/campaign/create'
    | '/admin/category-group/create'
    | '/admin/channel-config/$channelId'
    | '/admin/inbound-order/$orderId'
    | '/admin/item-mapping/create'
    | '/admin/item-mapping/import'
    | '/admin/menu-category/create'
    | '/admin/store-mapping/create'
    | '/auth/reset-password/$token'
    | '/admin/background-job'
    | '/admin/campaign'
    | '/admin/category-group'
    | '/admin/category-map'
    | '/admin/channel-config'
    | '/admin/channel-log'
    | '/admin/cron-setting'
    | '/admin/dashboard'
    | '/admin/inbound-order'
    | '/admin/item-mapping'
    | '/admin/menu-category'
    | '/admin/menu-preview'
    | '/admin/store-mapping'
    | '/admin/campaign/$id/detail'
    | '/admin/campaign/$id/update'
    | '/admin/category-group/$id/detail'
    | '/admin/category-group/$id/import'
    | '/admin/category-group/$id/preview'
    | '/admin/category-group/$id/update'
    | '/admin/category-map/$categoryID/detail'
    | '/admin/category-map/$categoryID/update'
    | '/admin/item-mapping/$id/detail'
    | '/admin/item-mapping/$id/update'
    | '/admin/menu-category/$id/detail'
    | '/admin/menu-category/$id/update'
    | '/admin/store-mapping/$id/detail'
    | '/admin/store-mapping/$id/update'
    | '/admin/category-group/$id/category/$categoryID/add-product'
    | '/admin/category-group/$id/category/$categoryID/products'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/admin/campaign/create'
    | '/admin/category-group/create'
    | '/admin/channel-config/$channelId'
    | '/admin/inbound-order/$orderId'
    | '/admin/item-mapping/create'
    | '/admin/item-mapping/import'
    | '/admin/menu-category/create'
    | '/admin/store-mapping/create'
    | '/auth/reset-password/$token'
    | '/admin/background-job'
    | '/admin/campaign'
    | '/admin/category-group'
    | '/admin/category-map'
    | '/admin/channel-config'
    | '/admin/channel-log'
    | '/admin/cron-setting'
    | '/admin/dashboard'
    | '/admin/inbound-order'
    | '/admin/item-mapping'
    | '/admin/menu-category'
    | '/admin/menu-preview'
    | '/admin/store-mapping'
    | '/admin/campaign/$id/detail'
    | '/admin/campaign/$id/update'
    | '/admin/category-group/$id/detail'
    | '/admin/category-group/$id/import'
    | '/admin/category-group/$id/preview'
    | '/admin/category-group/$id/update'
    | '/admin/category-map/$categoryID/detail'
    | '/admin/category-map/$categoryID/update'
    | '/admin/item-mapping/$id/detail'
    | '/admin/item-mapping/$id/update'
    | '/admin/menu-category/$id/detail'
    | '/admin/menu-category/$id/update'
    | '/admin/store-mapping/$id/detail'
    | '/admin/store-mapping/$id/update'
    | '/admin/category-group/$id/category/$categoryID/add-product'
    | '/admin/category-group/$id/category/$categoryID/products'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/403'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/admin/campaign/create'
    | '/admin/category-group/create'
    | '/admin/channel-config/$channelId'
    | '/admin/inbound-order/$orderId'
    | '/admin/item-mapping/create'
    | '/admin/item-mapping/import'
    | '/admin/menu-category/create'
    | '/admin/store-mapping/create'
    | '/auth/reset-password/$token'
    | '/admin/background-job/'
    | '/admin/campaign/'
    | '/admin/category-group/'
    | '/admin/category-map/'
    | '/admin/channel-config/'
    | '/admin/channel-log/'
    | '/admin/cron-setting/'
    | '/admin/dashboard/'
    | '/admin/inbound-order/'
    | '/admin/item-mapping/'
    | '/admin/menu-category/'
    | '/admin/menu-preview/'
    | '/admin/store-mapping/'
    | '/admin/campaign/$id/detail'
    | '/admin/campaign/$id/update'
    | '/admin/category-group/$id/detail'
    | '/admin/category-group/$id/import'
    | '/admin/category-group/$id/preview'
    | '/admin/category-group/$id/update'
    | '/admin/category-map/$categoryID/detail'
    | '/admin/category-map/$categoryID/update'
    | '/admin/item-mapping/$id/detail'
    | '/admin/item-mapping/$id/update'
    | '/admin/menu-category/$id/detail'
    | '/admin/menu-category/$id/update'
    | '/admin/store-mapping/$id/detail'
    | '/admin/store-mapping/$id/update'
    | '/admin/category-group/$id/category/$categoryID/add-product'
    | '/admin/category-group/$id/category/$categoryID/products'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  R403Route: typeof R403Route
  CheckEmailRoute: typeof CheckEmailRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-email': {
      id: '/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof CheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/store-mapping/': {
      id: '/admin/store-mapping/'
      path: '/store-mapping'
      fullPath: '/admin/store-mapping'
      preLoaderRoute: typeof AdminStoreMappingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/menu-preview/': {
      id: '/admin/menu-preview/'
      path: '/menu-preview'
      fullPath: '/admin/menu-preview'
      preLoaderRoute: typeof AdminMenuPreviewIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/menu-category/': {
      id: '/admin/menu-category/'
      path: '/menu-category'
      fullPath: '/admin/menu-category'
      preLoaderRoute: typeof AdminMenuCategoryIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/item-mapping/': {
      id: '/admin/item-mapping/'
      path: '/item-mapping'
      fullPath: '/admin/item-mapping'
      preLoaderRoute: typeof AdminItemMappingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inbound-order/': {
      id: '/admin/inbound-order/'
      path: '/inbound-order'
      fullPath: '/admin/inbound-order'
      preLoaderRoute: typeof AdminInboundOrderIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dashboard/': {
      id: '/admin/dashboard/'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/cron-setting/': {
      id: '/admin/cron-setting/'
      path: '/cron-setting'
      fullPath: '/admin/cron-setting'
      preLoaderRoute: typeof AdminCronSettingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/channel-log/': {
      id: '/admin/channel-log/'
      path: '/channel-log'
      fullPath: '/admin/channel-log'
      preLoaderRoute: typeof AdminChannelLogIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/channel-config/': {
      id: '/admin/channel-config/'
      path: '/channel-config'
      fullPath: '/admin/channel-config'
      preLoaderRoute: typeof AdminChannelConfigIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-map/': {
      id: '/admin/category-map/'
      path: '/category-map'
      fullPath: '/admin/category-map'
      preLoaderRoute: typeof AdminCategoryMapIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/': {
      id: '/admin/category-group/'
      path: '/category-group'
      fullPath: '/admin/category-group'
      preLoaderRoute: typeof AdminCategoryGroupIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaign/': {
      id: '/admin/campaign/'
      path: '/campaign'
      fullPath: '/admin/campaign'
      preLoaderRoute: typeof AdminCampaignIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/background-job/': {
      id: '/admin/background-job/'
      path: '/background-job'
      fullPath: '/admin/background-job'
      preLoaderRoute: typeof AdminBackgroundJobIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/auth/reset-password/$token': {
      id: '/auth/reset-password/$token'
      path: '/auth/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/store-mapping/create': {
      id: '/admin/store-mapping/create'
      path: '/store-mapping/create'
      fullPath: '/admin/store-mapping/create'
      preLoaderRoute: typeof AdminStoreMappingCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/menu-category/create': {
      id: '/admin/menu-category/create'
      path: '/menu-category/create'
      fullPath: '/admin/menu-category/create'
      preLoaderRoute: typeof AdminMenuCategoryCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/item-mapping/import': {
      id: '/admin/item-mapping/import'
      path: '/item-mapping/import'
      fullPath: '/admin/item-mapping/import'
      preLoaderRoute: typeof AdminItemMappingImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/item-mapping/create': {
      id: '/admin/item-mapping/create'
      path: '/item-mapping/create'
      fullPath: '/admin/item-mapping/create'
      preLoaderRoute: typeof AdminItemMappingCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/inbound-order/$orderId': {
      id: '/admin/inbound-order/$orderId'
      path: '/inbound-order/$orderId'
      fullPath: '/admin/inbound-order/$orderId'
      preLoaderRoute: typeof AdminInboundOrderOrderIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/channel-config/$channelId': {
      id: '/admin/channel-config/$channelId'
      path: '/channel-config/$channelId'
      fullPath: '/admin/channel-config/$channelId'
      preLoaderRoute: typeof AdminChannelConfigChannelIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/create': {
      id: '/admin/category-group/create'
      path: '/category-group/create'
      fullPath: '/admin/category-group/create'
      preLoaderRoute: typeof AdminCategoryGroupCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaign/create': {
      id: '/admin/campaign/create'
      path: '/campaign/create'
      fullPath: '/admin/campaign/create'
      preLoaderRoute: typeof AdminCampaignCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/store-mapping/$id/update': {
      id: '/admin/store-mapping/$id/update'
      path: '/store-mapping/$id/update'
      fullPath: '/admin/store-mapping/$id/update'
      preLoaderRoute: typeof AdminStoreMappingIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/store-mapping/$id/detail': {
      id: '/admin/store-mapping/$id/detail'
      path: '/store-mapping/$id/detail'
      fullPath: '/admin/store-mapping/$id/detail'
      preLoaderRoute: typeof AdminStoreMappingIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/menu-category/$id/update': {
      id: '/admin/menu-category/$id/update'
      path: '/menu-category/$id/update'
      fullPath: '/admin/menu-category/$id/update'
      preLoaderRoute: typeof AdminMenuCategoryIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/menu-category/$id/detail': {
      id: '/admin/menu-category/$id/detail'
      path: '/menu-category/$id/detail'
      fullPath: '/admin/menu-category/$id/detail'
      preLoaderRoute: typeof AdminMenuCategoryIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/item-mapping/$id/update': {
      id: '/admin/item-mapping/$id/update'
      path: '/item-mapping/$id/update'
      fullPath: '/admin/item-mapping/$id/update'
      preLoaderRoute: typeof AdminItemMappingIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/item-mapping/$id/detail': {
      id: '/admin/item-mapping/$id/detail'
      path: '/item-mapping/$id/detail'
      fullPath: '/admin/item-mapping/$id/detail'
      preLoaderRoute: typeof AdminItemMappingIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-map/$categoryID/update': {
      id: '/admin/category-map/$categoryID/update'
      path: '/category-map/$categoryID/update'
      fullPath: '/admin/category-map/$categoryID/update'
      preLoaderRoute: typeof AdminCategoryMapCategoryIDUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-map/$categoryID/detail': {
      id: '/admin/category-map/$categoryID/detail'
      path: '/category-map/$categoryID/detail'
      fullPath: '/admin/category-map/$categoryID/detail'
      preLoaderRoute: typeof AdminCategoryMapCategoryIDDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/$id/update': {
      id: '/admin/category-group/$id/update'
      path: '/category-group/$id/update'
      fullPath: '/admin/category-group/$id/update'
      preLoaderRoute: typeof AdminCategoryGroupIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/$id/preview': {
      id: '/admin/category-group/$id/preview'
      path: '/category-group/$id/preview'
      fullPath: '/admin/category-group/$id/preview'
      preLoaderRoute: typeof AdminCategoryGroupIdPreviewRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/$id/import': {
      id: '/admin/category-group/$id/import'
      path: '/category-group/$id/import'
      fullPath: '/admin/category-group/$id/import'
      preLoaderRoute: typeof AdminCategoryGroupIdImportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/$id/detail': {
      id: '/admin/category-group/$id/detail'
      path: '/category-group/$id/detail'
      fullPath: '/admin/category-group/$id/detail'
      preLoaderRoute: typeof AdminCategoryGroupIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaign/$id/update': {
      id: '/admin/campaign/$id/update'
      path: '/campaign/$id/update'
      fullPath: '/admin/campaign/$id/update'
      preLoaderRoute: typeof AdminCampaignIdUpdateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaign/$id/detail': {
      id: '/admin/campaign/$id/detail'
      path: '/campaign/$id/detail'
      fullPath: '/admin/campaign/$id/detail'
      preLoaderRoute: typeof AdminCampaignIdDetailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/$id/category/$categoryID/products': {
      id: '/admin/category-group/$id/category/$categoryID/products'
      path: '/category-group/$id/category/$categoryID/products'
      fullPath: '/admin/category-group/$id/category/$categoryID/products'
      preLoaderRoute: typeof AdminCategoryGroupIdCategoryCategoryIDProductsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/category-group/$id/category/$categoryID/add-product': {
      id: '/admin/category-group/$id/category/$categoryID/add-product'
      path: '/category-group/$id/category/$categoryID/add-product'
      fullPath: '/admin/category-group/$id/category/$categoryID/add-product'
      preLoaderRoute: typeof AdminCategoryGroupIdCategoryCategoryIDAddProductRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminCampaignCreateRoute: typeof AdminCampaignCreateRoute
  AdminCategoryGroupCreateRoute: typeof AdminCategoryGroupCreateRoute
  AdminChannelConfigChannelIdRoute: typeof AdminChannelConfigChannelIdRoute
  AdminInboundOrderOrderIdRoute: typeof AdminInboundOrderOrderIdRoute
  AdminItemMappingCreateRoute: typeof AdminItemMappingCreateRoute
  AdminItemMappingImportRoute: typeof AdminItemMappingImportRoute
  AdminMenuCategoryCreateRoute: typeof AdminMenuCategoryCreateRoute
  AdminStoreMappingCreateRoute: typeof AdminStoreMappingCreateRoute
  AdminBackgroundJobIndexRoute: typeof AdminBackgroundJobIndexRoute
  AdminCampaignIndexRoute: typeof AdminCampaignIndexRoute
  AdminCategoryGroupIndexRoute: typeof AdminCategoryGroupIndexRoute
  AdminCategoryMapIndexRoute: typeof AdminCategoryMapIndexRoute
  AdminChannelConfigIndexRoute: typeof AdminChannelConfigIndexRoute
  AdminChannelLogIndexRoute: typeof AdminChannelLogIndexRoute
  AdminCronSettingIndexRoute: typeof AdminCronSettingIndexRoute
  AdminDashboardIndexRoute: typeof AdminDashboardIndexRoute
  AdminInboundOrderIndexRoute: typeof AdminInboundOrderIndexRoute
  AdminItemMappingIndexRoute: typeof AdminItemMappingIndexRoute
  AdminMenuCategoryIndexRoute: typeof AdminMenuCategoryIndexRoute
  AdminMenuPreviewIndexRoute: typeof AdminMenuPreviewIndexRoute
  AdminStoreMappingIndexRoute: typeof AdminStoreMappingIndexRoute
  AdminCampaignIdDetailRoute: typeof AdminCampaignIdDetailRoute
  AdminCampaignIdUpdateRoute: typeof AdminCampaignIdUpdateRoute
  AdminCategoryGroupIdDetailRoute: typeof AdminCategoryGroupIdDetailRoute
  AdminCategoryGroupIdImportRoute: typeof AdminCategoryGroupIdImportRoute
  AdminCategoryGroupIdPreviewRoute: typeof AdminCategoryGroupIdPreviewRoute
  AdminCategoryGroupIdUpdateRoute: typeof AdminCategoryGroupIdUpdateRoute
  AdminCategoryMapCategoryIDDetailRoute: typeof AdminCategoryMapCategoryIDDetailRoute
  AdminCategoryMapCategoryIDUpdateRoute: typeof AdminCategoryMapCategoryIDUpdateRoute
  AdminItemMappingIdDetailRoute: typeof AdminItemMappingIdDetailRoute
  AdminItemMappingIdUpdateRoute: typeof AdminItemMappingIdUpdateRoute
  AdminMenuCategoryIdDetailRoute: typeof AdminMenuCategoryIdDetailRoute
  AdminMenuCategoryIdUpdateRoute: typeof AdminMenuCategoryIdUpdateRoute
  AdminStoreMappingIdDetailRoute: typeof AdminStoreMappingIdDetailRoute
  AdminStoreMappingIdUpdateRoute: typeof AdminStoreMappingIdUpdateRoute
  AdminCategoryGroupIdCategoryCategoryIDAddProductRoute: typeof AdminCategoryGroupIdCategoryCategoryIDAddProductRoute
  AdminCategoryGroupIdCategoryCategoryIDProductsRoute: typeof AdminCategoryGroupIdCategoryCategoryIDProductsRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminCampaignCreateRoute: AdminCampaignCreateRoute,
  AdminCategoryGroupCreateRoute: AdminCategoryGroupCreateRoute,
  AdminChannelConfigChannelIdRoute: AdminChannelConfigChannelIdRoute,
  AdminInboundOrderOrderIdRoute: AdminInboundOrderOrderIdRoute,
  AdminItemMappingCreateRoute: AdminItemMappingCreateRoute,
  AdminItemMappingImportRoute: AdminItemMappingImportRoute,
  AdminMenuCategoryCreateRoute: AdminMenuCategoryCreateRoute,
  AdminStoreMappingCreateRoute: AdminStoreMappingCreateRoute,
  AdminBackgroundJobIndexRoute: AdminBackgroundJobIndexRoute,
  AdminCampaignIndexRoute: AdminCampaignIndexRoute,
  AdminCategoryGroupIndexRoute: AdminCategoryGroupIndexRoute,
  AdminCategoryMapIndexRoute: AdminCategoryMapIndexRoute,
  AdminChannelConfigIndexRoute: AdminChannelConfigIndexRoute,
  AdminChannelLogIndexRoute: AdminChannelLogIndexRoute,
  AdminCronSettingIndexRoute: AdminCronSettingIndexRoute,
  AdminDashboardIndexRoute: AdminDashboardIndexRoute,
  AdminInboundOrderIndexRoute: AdminInboundOrderIndexRoute,
  AdminItemMappingIndexRoute: AdminItemMappingIndexRoute,
  AdminMenuCategoryIndexRoute: AdminMenuCategoryIndexRoute,
  AdminMenuPreviewIndexRoute: AdminMenuPreviewIndexRoute,
  AdminStoreMappingIndexRoute: AdminStoreMappingIndexRoute,
  AdminCampaignIdDetailRoute: AdminCampaignIdDetailRoute,
  AdminCampaignIdUpdateRoute: AdminCampaignIdUpdateRoute,
  AdminCategoryGroupIdDetailRoute: AdminCategoryGroupIdDetailRoute,
  AdminCategoryGroupIdImportRoute: AdminCategoryGroupIdImportRoute,
  AdminCategoryGroupIdPreviewRoute: AdminCategoryGroupIdPreviewRoute,
  AdminCategoryGroupIdUpdateRoute: AdminCategoryGroupIdUpdateRoute,
  AdminCategoryMapCategoryIDDetailRoute: AdminCategoryMapCategoryIDDetailRoute,
  AdminCategoryMapCategoryIDUpdateRoute: AdminCategoryMapCategoryIDUpdateRoute,
  AdminItemMappingIdDetailRoute: AdminItemMappingIdDetailRoute,
  AdminItemMappingIdUpdateRoute: AdminItemMappingIdUpdateRoute,
  AdminMenuCategoryIdDetailRoute: AdminMenuCategoryIdDetailRoute,
  AdminMenuCategoryIdUpdateRoute: AdminMenuCategoryIdUpdateRoute,
  AdminStoreMappingIdDetailRoute: AdminStoreMappingIdDetailRoute,
  AdminStoreMappingIdUpdateRoute: AdminStoreMappingIdUpdateRoute,
  AdminCategoryGroupIdCategoryCategoryIDAddProductRoute:
    AdminCategoryGroupIdCategoryCategoryIDAddProductRoute,
  AdminCategoryGroupIdCategoryCategoryIDProductsRoute:
    AdminCategoryGroupIdCategoryCategoryIDProductsRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  R403Route: R403Route,
  CheckEmailRoute: CheckEmailRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
